import { actions, getters } from '@utils'
import BoardView from '@components/board/BoardView'
import { optionallyCall } from '@utils/functions'
import { toActionName } from '@store/utils'

// TODO: simplify
// eslint-disable-next-line sonarjs/cognitive-complexity
export default (serviceName, options = {}) => {
  if (typeof options === 'string') options = { redirectTo: options }

  const {
    factory = {},
    redirectTo,
    stateKey = serviceName,
    successMessage,

    factoryName = `${stateKey || ''}Factory`,
  } = options

  // TODO: generalize with BoardSingle
  const actionSuffix = toActionName(serviceName)
  const getFactoryOverride = thisContext => optionallyCall(factory, thisContext, thisContext)
  const suffixAction = prefix => `${prefix}_${actionSuffix}`

  return {
    components: { BoardView },
    data() {
      return {
        isSaving: false,
        ...stateKey
          ? { [stateKey]: this.$store.getters[factoryName](getFactoryOverride(this)) }
          : {},
      }
    },
    computed: getters(),
    methods: {
      createDirect(record) {
        return this[suffixAction('CREATE')](record)
      },
      async create(record) {
        try {
          this.isSaving = true
          const recordCreated = await this.createDirect(record || this[stateKey])

          if (successMessage) {
            this.$store.dispatch('SUCCESS', optionallyCall(successMessage, this, this))
          }

          // optionally injected by Modal mixin
          if (this.isModal) {
            this.$emit('created', recordCreated)
            this.close(true)
            return
          }

          if (redirectTo === null || this.$route.name === redirectTo) return

          const redirectRoute = optionallyCall(redirectTo, [this, recordCreated], this) ||
            `${this.$route.name.slice(0, -3)}s`

          const routeQuery = { isRefetch: true }

          // TODO: merge redirectRoute and routeQuery
          this.$router.push(typeof redirectRoute === 'string'
            ? {
              name: redirectRoute,
              query: routeQuery,
            }
            : {
              query: routeQuery,
              ...redirectRoute,
            })
        } finally {
          this.isSaving = false
        }
      },
      ...actions(suffixAction('CREATE')),
    },
    beforeMount() {
      // NOTE: fixes issue when factory depends on state that has not been loaded
      this.POST_LOAD(() => {
        if (!stateKey) return

        this[stateKey] = this.$store.getters[factoryName](getFactoryOverride(this))
      })
    },
    render: () => '',
  }
}
